import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "dialog",
    "form",
    "formPanel",
    "successPanel",
    "successPost",
    "successPatron",
    "error",
    "typeSelect",
    "totalLabel",
    "amountInput",
    "cadenceInput",
    "startDate",
    "adCopy",
    "notes",
    "postFields",
    "patronFields",
    "adSectionLegend",
    "companyLabel",
    "linkLabel",
    "submit"
  ]

  open(event) {
    this.applyType(event.params.id)

    this.formPanelTarget.hidden = false
    this.successPanelTarget.hidden = true
    this.errorTarget.hidden = true
    this.errorTarget.textContent = ""
    this.submitTarget.disabled = false
    this.dialogTarget.showModal()
  }

  changeType() {
    this.applyType(this.typeSelectTarget.value)
  }

  close() {
    this.dialogTarget.close()
  }

  async submit(event) {
    event.preventDefault()
    this.errorTarget.hidden = true
    this.submitTarget.disabled = true

    const form = this.formTarget
    const body = new URLSearchParams(new FormData(form)).toString()

    try {
      const response = await fetch(window.location.pathname, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body,
        signal: AbortSignal.timeout(15000)
      })

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`)
      }

      const isPost = this.typeSelectTarget.value === "upcoming_post"
      form.reset()
      this.formPanelTarget.hidden = true
      this.successPanelTarget.hidden = false
      this.successPostTarget.hidden = !isPost
      this.successPatronTarget.hidden = isPost
    } catch (error) {
      console.error(error)
      this.errorTarget.textContent = "The form didn't send. Email me instead at hello@minitestrails.com, or try again."
      this.errorTarget.hidden = false
      this.submitTarget.disabled = false
    }
  }

  applyType(id) {
    const option = this.typeSelectTarget.querySelector(`option[value="${id}"]`)
    if (!option) return

    this.typeSelectTarget.value = id
    this.amountInputTarget.value = option.dataset.amount
    this.cadenceInputTarget.value = option.dataset.cadence
    this.totalLabelTarget.textContent = this.totalCopy(option.dataset.amount, option.dataset.cadence)

    const isPost = id === "upcoming_post"
    this.postFieldsTarget.hidden = !isPost
    this.adCopyTarget.required = isPost
    this.patronFieldsTarget.hidden = isPost
    this.startDateTarget.required = !isPost
    this.startDateTarget.disabled = isPost
    this.adSectionLegendTarget.textContent = isPost ? "Your ad" : "Your details"
    this.companyLabelTarget.textContent = isPost ? "Company or product name" : "Product or company name"
    this.linkLabelTarget.textContent = isPost ? "Ad link" : "Website"

    if (isPost) {
      this.startDateTarget.value = ""
    } else {
      this.adCopyTarget.value = ""
      const today = this.localDate()
      this.startDateTarget.min = today
      if (!this.startDateTarget.value || this.startDateTarget.value < today) {
        this.startDateTarget.value = today
      }
    }
  }

  totalCopy(amount, cadence) {
    if (cadence === "monthly") {
      return `$${amount} per month`
    }

    return `$${amount} one-time`
  }

  localDate() {
    const now = new Date()
    const month = String(now.getMonth() + 1).padStart(2, "0")
    const day = String(now.getDate()).padStart(2, "0")
    return `${now.getFullYear()}-${month}-${day}`
  }
}
